import type { Components, Theme } from '@mui/material/styles';

export const tableComponents: Components<Theme> = {
    MuiTableCell: {
        styleOverrides: {
            root: {
                padding: 12,
            },
        },
    },
};